import React from 'react';
import {COLORS, SIZES, Typography} from '@fupa/fupa-uikit';
import {styled} from '@mui/material/styles';
import {Section} from './cards/CardStyles';
import FreeTrialButton from './components/FreeTrialButton';
import ContentImage from './components/ContentImage';

const Container = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: end;
  width: 100%;
  max-width: 1200px;
  z-index: 1;
  padding-top: ${SIZES['112']};
  padding-bottom: 2rem;
  padding-left: 2rem;

  @media all and (max-width: 800px) {
    flex-direction: column;
    padding-left: 1rem;
    padding-right: 1rem;
  }
`;

const TextContainer = styled('div')`
  width: 50%;
  text-align: left;
  @media all and (max-width: 800px) {
    width: 100%;
    text-align: center;
  }
`;

const Heading = styled(Typography)`
  &&& {
    color: ${COLORS.white};
    @media all and (max-width: 800px) {
      font-size: ${SIZES['32']};
    }
  }
`;

const Subheading = styled(Typography)`
  &&& {
    margin-bottom: 2rem;
    @media all and (max-width: 800px) {
      font-size: ${SIZES['18']};
    }
  }
`;

const Header = () => {
  return (
    <Section backgroundColor={COLORS.fupaPrimary} primaryGradient>
      <Container>
        <TextContainer>
          <Heading variant='display2' component='h1'>
            Einfache Website-Pflege mit FuPa Widgets
          </Heading>
          <Subheading variant='title1' component='h2'>
            Erweitert eure Vereinswebseite schnell und einfach mit den wichtigsten Fußballdaten eurer Teams - von Kader
            über Tabelle, Liveticker und Spielerstatistik bis hin zum Spielplan
          </Subheading>
          <FreeTrialButton />
        </TextContainer>
        <ContentImage
          fetchPriority={'high'}
          imgHeight={300}
          imgWidth={516}
          imgAlt='Darstellung der FuPa Widgets auf Webseite'
          imgSrc={'/landingpage_team_widgets_compressed'}
        />
      </Container>
    </Section>
  );
};

export default Header;
